<template>
  <div class="productBox" v-if="tabList.length > 0">
    <div class="head">
      <div class="title" v-if="title !== ''">{{title}}</div>
      <div class="tabList">
      <span
        v-for="(item,index) in tabList" :key="index"
        :class="['tab',(tabIndex === index ? 'tabActive' : '')]"
        @click="tabChange(index)"
      >{{item}}</span>
      </div>
    </div>
    <div class="tabBody">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductBox',
  data () {
    return {
      tabIndex: 0
    }
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    tabList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  methods: {
    tabChange (index) {
      this.tabIndex = index
      this.$emit('tabChange', this.tabList[index])
    }
  }
}
</script>

<style scoped lang="scss">
.productBox{
  display: inline-block;
  width: 100%;

  & .head{
    position: relative;
    display: flex;
    width: 100%;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;

    & .title{
      position: relative;
      width: 260px;
      flex-shrink: 0;
      font-size: 28px;
      color: #0f294d;
      letter-spacing: 0;
      line-height: 34px;
      font-weight: 700;

      &::before{
        content: "";
        display: block;
        position: absolute;
        left: -12px;
        z-index: 0;
        top: -5px;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 18px 18px 0 0;
        border-color: #3264ff transparent transparent;
      }
    }

    & .tabList{
      flex:1;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-items: center;
      justify-content: flex-end;

      & .tabActive{
        font-weight: 700;
        border-color: rgba(50,100,255,.0784313725490196);
        color: #3264ff !important;
        background-color: rgba(50,100,255,.0784313725490196);
      }
      & .tab{
        cursor: pointer;
        display: inline-block;
        font-size: 14px;
        line-height: 18px;
        padding: 8px 16px;
        margin-right: 16px;
        border: 1px solid #dadfe6;
        border-radius: 2px;
        color: #0f294d;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/global/productBox.vue